import { childrenFilterData } from "../config/childrenFilterData";
import useFilterSort from "./useFilterSort";

export function useChildrenFilterSort() {
  return useFilterSort<Record<string, string | number>>(childrenFilterData);
}
